/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/rules-of-hooks */
/* eslint-disable no-else-return */
/* eslint-disable arrow-body-style */
import { Popover, Box, Typography } from '@mui/material';
import { makeStyles } from '@mui/styles';
import ValidationDialog from 'components/therapy/ValidationDialog';
import useAuth from 'hooks/useAuth';
import usePermission from 'hooks/usePermission';
import { useState } from 'react';
import { useCheckPermissionMutation } from 'store/services/therapy/evaluation';
import { markQuickActionOtherServiceHistory } from 'utils/quickActionHistory';

const useStyles = makeStyles(() => ({
    popover: {
        pointerEvents: 'none'
    },
    popoverContent: {
        pointerEvents: 'auto'
    }
}));

const sectionLabelSx = {
    mb: 1,
    color: '#8a8c93',
    fontSize: 11,
    fontWeight: 700,
    letterSpacing: 1,
    lineHeight: 1,
    textTransform: 'uppercase'
};

const actionRowSx = {
    width: '100%',
    minHeight: 40,
    border: 0,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    gap: 1,
    px: 1.5,
    py: 1,
    borderRadius: 1,
    cursor: 'pointer',
    color: '#565b64',
    backgroundColor: '#f5f5f7',
    textAlign: 'left',
    font: 'inherit',
    transition: 'background-color .15s ease, color .15s ease',
    '&:hover': {
        color: '#FFFFFF',
        backgroundColor: '#1b357c'
    }
};

const OTHER_SERVICES_TAB = 'other-services';
const QUICK_ACTION_BACKGROUND = '#FFFFFF';

const ActionRow = ({ children, onClick }) => (
    <Box component="button" type="button" onClick={onClick} sx={actionRowSx}>
        <Typography sx={{ color: 'inherit', fontSize: 14, fontWeight: 600 }}>{children}</Typography>
    </Box>
);

const TherapyActionPanel = ({ service, userPermissions, setMissedNoteOpen, setService, closePopover }) => {
    const { isSuperAdmin } = usePermission();
    const { user } = useAuth();
    const [checkPermission] = useCheckPermissionMutation();
    const [openValidation, setValidationOpen] = useState(false);
    const [validationResp, setValidationResp] = useState([]);

    const handleValidationClose = () => {
        setValidationOpen(false);
    };

    const handleClick = async (type) => {
        try {
            // 1️⃣ Call your API before navigation
            if (!isSuperAdmin) {
                await checkPermission({
                    employee_id: user?.emp_id,
                    client_id: user?.client_id,
                    is_evaluation: type === 'evaluation' ? 1 : 0,
                    source: 'therapy'
                }).unwrap();
            }
            setValidationOpen(false);
            setValidationResp([]);
            window.location.href = `/therapy/${service?.shorthand}/${type}/create`;
            // 2️⃣ Navigate after success
            // navigate(`/therapy/${service?.shorthand}/${type}/create`);
        } catch (error) {
            const validationMessage = error?.data?.messages || error?.data?.message;
            const normalizedValidationResp = Array.isArray(validationMessage)
                ? validationMessage.filter(Boolean)
                : typeof validationMessage === 'string' && validationMessage.trim()
                  ? [validationMessage]
                  : [];

            if (Number(error?.status) === 400 && normalizedValidationResp.length > 0) {
                setValidationOpen(true);
                setValidationResp(normalizedValidationResp);
                return;
            }

            setValidationOpen(false);
            setValidationResp([]);
        }
    };

    if (!service) {
        return null;
    }

    return (
        <>
            <Box sx={{ display: 'grid', gap: 0.75 }}>
                {userPermissions?.includes(`${service?.shorthand}_eval_view`) && (
                    <ActionRow onClick={() => handleClick('evaluation')}>Evaluation</ActionRow>
                )}
                {userPermissions?.includes(`${service?.shorthand}_note_view`) && (
                    <ActionRow onClick={() => handleClick('treatment')}>Treatment</ActionRow>
                )}
                <ActionRow
                    onClick={() => {
                        closePopover();
                        setMissedNoteOpen(true);
                        setService(service?.shorthand);
                    }}
                >
                    Add Missed Note
                </ActionRow>
            </Box>
            <ValidationDialog open={openValidation} onClose={handleValidationClose} validationResp={validationResp} />
        </>
    );
};

const PopoverNavigation = ({
    open,
    anchorEl,
    openPopover,
    closePopover,
    innerList,
    directList = [],
    permissionsList,
    setMissedNoteOpen,
    setService
}) => {
    const classes = useStyles();

    const { isSuperAdmin, isServiceAvailable } = usePermission();
    const [value, setValue] = useState(0);

    const availableTherapyActions =
        innerList?.filter((item) => {
            const atleastOnePerExist = item?.permission?.some((p) => permissionsList?.includes(p));
            return atleastOnePerExist && (isSuperAdmin || isServiceAvailable(item?.shorthand));
        }) || [];

    const availableDirectActions =
        directList?.filter((item) => {
            const atleastOnePerExist = item?.permissions?.some((p) => permissionsList?.includes(p));
            return atleastOnePerExist && (isSuperAdmin || isServiceAvailable(item?.service));
        }) || [];

    const selectedTherapy =
        value === OTHER_SERVICES_TAB ? null : availableTherapyActions.find((item) => item?.id === value) || availableTherapyActions?.[0];
    const isOtherServicesSelected = value === OTHER_SERVICES_TAB || (!selectedTherapy && availableDirectActions.length > 0);

    const handleDirectActionClick = (url) => {
        closePopover();
        markQuickActionOtherServiceHistory(url);
        window.location.href = url;
    };

    return (
        <Popover
            className={classes.popover}
            classes={{
                paper: classes.popoverContent
            }}
            open={open}
            anchorEl={anchorEl}
            anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'center'
            }}
            transformOrigin={{
                vertical: 'top',
                horizontal: 'center'
            }}
            slotProps={{
                paper: {
                    onMouseEnter: openPopover,
                    onMouseLeave: closePopover,
                    style: {
                        backgroundColor: 'transparent',
                        boxShadow: 'none',
                        borderRadius: 0,
                        overflow: 'visible'
                    }
                }
            }}
        >
            <Box
                sx={{
                    position: 'relative',
                    marginTop: '10px'
                }}
            >
                <Box
                    sx={{
                        position: 'absolute',
                        top: -7,
                        left: '50%',
                        width: 14,
                        height: 14,
                        backgroundColor: QUICK_ACTION_BACKGROUND,
                        boxShadow: '-3px -3px 6px rgba(0,0,0,0.08)',
                        transform: 'translateX(-50%) rotate(45deg)',
                        zIndex: 0
                    }}
                />
                <Box
                    sx={{
                        position: 'relative',
                        zIndex: 1,
                        width: 300,
                        display: 'grid',
                        p: 2.5,
                        borderRadius: 1.5,
                        backgroundColor: QUICK_ACTION_BACKGROUND,
                        boxShadow: '0px 6px 22px rgba(0,0,0,0.24)'
                    }}
                >
                    {(availableTherapyActions.length > 0 || availableDirectActions.length > 0) && (
                        <Box>
                            <Typography sx={sectionLabelSx}>Quick Actions</Typography>
                            <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1, mb: 1.25 }}>
                                {availableTherapyActions.map((item) => {
                                    const selected = Boolean(selectedTherapy) && item?.id === selectedTherapy?.id;
                                    return (
                                        <Box
                                            key={item?.label}
                                            component="button"
                                            type="button"
                                            onClick={() => {
                                                setValue(item?.id);
                                                setService(item?.shorthand);
                                            }}
                                            onMouseOver={() => {
                                                setValue(item?.id);
                                                setService(item?.shorthand);
                                            }}
                                            sx={{
                                                minWidth: 32,
                                                height: 24,
                                                border: 0,
                                                px: 1,
                                                borderRadius: 1,
                                                cursor: 'pointer',
                                                color: selected ? '#FFFFFF' : '#4b4f58',
                                                backgroundColor: selected ? '#1b357c' : '#ececef',
                                                fontSize: 12,
                                                fontWeight: 700,
                                                lineHeight: 1,
                                                transition: 'background-color .15s ease, color .15s ease',
                                                '&:hover': {
                                                    color: '#FFFFFF',
                                                    backgroundColor: '#1b357c'
                                                }
                                            }}
                                        >
                                            {item?.shorthand?.toUpperCase()}
                                        </Box>
                                    );
                                })}
                                {availableDirectActions.length > 0 && (
                                    <Box
                                        component="button"
                                        type="button"
                                        onClick={() => {
                                            setValue(OTHER_SERVICES_TAB);
                                            setService(null);
                                        }}
                                        onMouseOver={() => {
                                            setValue(OTHER_SERVICES_TAB);
                                            setService(null);
                                        }}
                                        sx={{
                                            minWidth: 96,
                                            height: 24,
                                            border: 0,
                                            px: 1,
                                            borderRadius: 1,
                                            cursor: 'pointer',
                                            color: isOtherServicesSelected ? '#FFFFFF' : '#4b4f58',
                                            backgroundColor: isOtherServicesSelected ? '#1b357c' : '#ececef',
                                            fontSize: 12,
                                            fontWeight: 700,
                                            lineHeight: 1,
                                            transition: 'background-color .15s ease, color .15s ease',
                                            '&:hover': {
                                                color: '#FFFFFF',
                                                backgroundColor: '#1b357c'
                                            }
                                        }}
                                    >
                                        Other Services
                                    </Box>
                                )}
                            </Box>
                            {selectedTherapy && (
                                <TherapyActionPanel
                                    service={selectedTherapy}
                                    userPermissions={permissionsList}
                                    setMissedNoteOpen={setMissedNoteOpen}
                                    setService={setService}
                                    closePopover={closePopover}
                                />
                            )}
                            {isOtherServicesSelected && availableDirectActions.length > 0 && (
                                <Box sx={{ display: 'grid', gap: 0.75 }}>
                                    {availableDirectActions.map((item) => (
                                        <ActionRow
                                            key={item.id}
                                            onClick={() => handleDirectActionClick(item.url)}
                                        >
                                            {item.label}
                                        </ActionRow>
                                    ))}
                                </Box>
                            )}
                        </Box>
                    )}
                </Box>
            </Box>
        </Popover>
    );
};

export default PopoverNavigation;
